import useIsMobile from "../../../hooks/useIsMobile";
import { useEffect, useState, useRef } from "react";
import { formatCategoriesAndHighlights } from "../../../utils/GenUtils";
import Modal from "react-responsive-modal";
import ReactPlayer from "react-player";
import styles from "../../../styles/videos.module.css";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { BsYoutube } from "react-icons/bs";
import { useSelector } from "react-redux";
import Image from "next/image";
import youtubeThumbnail from "youtube-thumbnail";
import Head from "next/head";
import ReadMore from "../../../components/Readmore";
import { Constants } from "../../../helpers/constants";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
const IMAGE_GALLERY_CONSTANT=Constants?.allcomponents;
import DisclaimerTag from "../../../components/DisclaimerTags/DisclaimerTag/DisclaimerTag";
import DisclaimerFooterList from "../../../components/DisclaimerTags/DisclaimerFooter/DisclaimerFooterList";

const GenericTemplate = (props) => {
  const mobile = useIsMobile();
  const [showPlayer, setShowPlayer] = useState(false);
  // const [data, setData] = useState([]);
  let data =[];
  const [selectedUrl, setSelectedUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hideImage, setHideImage] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [isLoadingMobile, setIsLoadingMobile] = useState(true);
  const playerContainerRef = useRef(null);
  const disclaimerSetting = useSelector((state) => state?.app?.disclaimerSetting);

  // useEffect(() => {
  //   setData(
  //     formatCategoriesAndHighlights(
  //       props.data.highlights,
  //       props.data.categories,
  //     ),
  //   );
  // }, []);
  if(props?.data?.highlights ||props?.data?.categories )
    {
      data=formatCategoriesAndHighlights(
              props?.data?.highlights,
              props?.data?.categories,
            );
    }

    const playerRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);
    
    // Focus the player container when modal opens
    useEffect(() => {
      if (showPlayer && playerContainerRef.current) {
        playerContainerRef.current.focus();
      }
    }, [showPlayer]);

    // Toggle play/pause on Enter/Space key
  const handleKeyDown = (e) => {
    if (!showPlayer) return;

  // ESCAPE: Close the modal
  if (e.key === "Escape") {
    setShowPlayer(false);
    setIsPlaying(false);
    return;
  }

  // ENTER or SPACE: Toggle play/pause
  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    const internalPlayer = playerRef.current?.getInternalPlayer();
    if (!internalPlayer) return;

    try {
        // For YouTube videos
      if (typeof internalPlayer.playVideo === "function") {
            // YouTube player
        if (isPlaying) {
          internalPlayer.pauseVideo();
        } else {
          internalPlayer.playVideo();
        }
      } else if (typeof internalPlayer.pause === "function") {
            // HTML5 player
        if (isPlaying) {
          internalPlayer.pause();
        } else {
          internalPlayer.play();
        }
      }

      setIsPlaying((prev) => !prev);
    } catch (err) {
      console.warn("Error toggling video play/pause:", err);
    }
  }
};

  return (
    <>
      <Head>
        <title>{props?.data?.seo_settings?.meta_title}</title>
        <meta
          name="description"
          content={props?.data?.seo_settings?.meta_desc}
        />
        <meta name="keywords" content={props?.data?.seo_settings?.keywords} />
        <meta name="keywords" content={props?.data?.seo_settings?.keywords} />
      </Head>
      {/* VIDEO MODAL  */}
    <Modal
        onClose={() => setShowPlayer(false)}
  open={showPlayer}
  classNames={{
    modal: "topicSlide__modal",
  }}
>
  <div
        ref={playerContainerRef}
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
  <ReactPlayer
    ref={playerRef}
    fullScreen={true}
    url={selectedUrl}
    playing={isPlaying}
    volume={1}
    controls
    width={mobile ? "90vw" : "65vw"}
    height={mobile ? "50vw" : "35vw"}
  />
  </div>  
</Modal>

      {/* VIDEO MODELS TAB  */}
      <div className={styles.videos_wrap}>
        <div className="container">
        <h1 className={styles.videos_heads}>{IMAGE_GALLERY_CONSTANT?.VIDEOS?IMAGE_GALLERY_CONSTANT?.VIDEOS:"Videos"}</h1>
          
          <div className="videos-wrapper">
            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
              <TabList
                className="react-tabs__tab-list"
                style={{ marginBottom: "48px" }}
              >
                {data?.map((item, i) => (
                  <Tab
                    key={i}
                    tabIndex="0"
                    className="react-tabs__tab"
                    aria-selected={tabIndex === i}
                    onClick={() => setTabIndex(i)}
                    onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault(); 
                      setTabIndex(i);   
                    }
                  }}
                   >
                    {item.categoryName}</Tab>
                ))}
              </TabList>

              {data?.length > 0 &&
                data.map((data, index) => {
                  return (
                    <TabPanel
                      key={index}
                      className="grid grid-cols-1 md:grid-cols-4 gap-x-[48px] md:gap-x-[16px] lg:gap-x-[48px] gap-y-12"
                    >
                      {data.highlights &&
                        data.highlights.map((ele, index) => (
                          <>
                            <div
                             key={index}
                             role="button"               
                             tabIndex={0}
                              aria-label={`Play video: ${ele.title}`}
                              onClick={() => {
                                setShowPlayer(true);
                                setSelectedUrl(ele.youtube_link);
                                setIsPlaying(false); // Ensure video is paused when modal opens
                              }}
                              onKeyDown={(e) => {
                              if (e.key === "Enter" || e.key === " ") {
                                e.preventDefault();
                                setShowPlayer(!mobile ? true : false);
                                setSelectedUrl(ele.youtube_link);
                                setIsPlaying(false); // video paused initially
                              }
        }}
                              className={styles.video_grid}
                            >
                              <div className="video-sec relative">
                                <span className={styles.videos_icons} aria-hidden="true">
                                  <BsYoutube size={50} color={"red"} />
                                </span>
                                {/* {isLoading && !hideImage && <Skeleton height={mobile ? "415" : "231"} width={mobile ? "768" : "418"} />} */}
                                {!hideImage && (
                                <Image
                                  src={
                                    youtubeThumbnail(ele.youtube_link).medium
                                      .url
                                  }
                                  // className=""
                                  className={isLoading ? "hidden" : "block"}
                                  // width={398}
                                  // height={221}
                                  width={!isLoading ? mobile ? "768" : "418":0}
                                  height={!isLoading ? mobile ? "415" : "231":0}
                                  alt=""
                                  onLoad={() => setIsLoading(false)}
                                  onError={() => setHideImage(true)}
                                />
                                )}
                              </div>
                              <span className={styles.video_grid_head}>
                                {ele.title}
                              </span>
                              {/* <p
                                className={styles.video_grid_paragraph}
                                dangerouslySetInnerHTML={{
                                  __html: ele.desc,
                                }}
                              /> */}
                              <ReadMore text={ele.desc} />
                              {disclaimerSetting && disclaimerSetting?.publishedValue && (
                              <DisclaimerTag
                                disclaimerData={ele?.disclaimers || null}
                                type="slide" />)}
                            </div>
                          </>
                        ))}
                    </TabPanel>
                  );
                })}
            </Tabs>
          </div>
        </div>
      </div>
      {props?.data?.primary_details?.tnc && (
          <div
          className="container unreset"
          id="video_gallery_t&c"
            // className={`unreset my-10 sm:w-[90%] container ${
            //   !isBannerVisible && "mt-[100px]"
            // } ${newData?.fleet?.order_index === null ? "lg:w-[50%]" : ""}`}
            dangerouslySetInnerHTML={{
              __html: props?.data?.primary_details?.tnc,
            }}
          />
        )}

          {disclaimerSetting && disclaimerSetting?.publishedValue && props?.data?.disclaimer_footer && (
                  <DisclaimerFooterList 
                  disclaimerList={props?.data?.disclaimer_footer?.disclaimers}
                  />
                )}
    </>
  );
};

export default GenericTemplate;
